import { render, staticRenderFns } from "./SunmiConfigSidebar.vue?vue&type=template&id=3158e6ab&scoped=true"
import script from "./SunmiConfigSidebar.vue?vue&type=script&lang=js"
export * from "./SunmiConfigSidebar.vue?vue&type=script&lang=js"
import style0 from "./SunmiConfigSidebar.vue?vue&type=style&index=0&id=3158e6ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3158e6ab",
  null
  
)

export default component.exports